// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import { axios } from './http/base'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import './assets/fonts/iconfont.css'
import "font-awesome/css/font-awesome.css";
import "animate.css";

import ECharts from 'vue-echarts/components/ECharts'
// import ECharts modules manually to reduce bundle size
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/pie'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/markLine'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/dataZoom'

import Distpicker from 'v-distpicker'
Vue.component('v-distpicker', Distpicker)

// register component to use
Vue.component('chart', ECharts)


import Imager from '@/components/Imager';
Vue.component('Imager', Imager)
import Uploader from '@/components/Uploader';
Vue.component('Uploader', Uploader)
import Drawer from '@/components/Drawer';
Vue.component('Drawer', Drawer)

import store from './store'

import moment from 'moment'
Vue.prototype.$moment = moment

Vue.use(ElementUI)

import {
  visable,
  transferDom
} from './directives';
Vue.directive('visable', visable);
Vue.directive('transfer-dom', transferDom);

// 引入mqtt
import './mq'

Vue.config.productionTip = false

// 挂载到prototype上面，确保组件中可以直接使用this.axios
// Vue.prototype.axios = axios

import './util/filters';

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js